import Vue from 'vue'
import VueMarkdown from 'vue-markdown'
import imageBlock from '@/components/imageBlock'

import { mapGetters, mapActions } from 'vuex'
import textblockBase from '@/components/textblockBase.js'

import Parallax from '@/components/parallax'

// import anime from 'animejs'

// Directives
import inViewportDirective from 'vue-in-viewport-directive'
// import VueParallaxJs from 'vue-parallax-js'

// Vue.use(VueParallaxJs)
Vue.directive('in-viewport', inViewportDirective)

export default {
  props: [ 'payload' ],
  mixins: [ textblockBase ],
  components: { VueMarkdown, imageBlock, Parallax },
  data () {
    return {
      link: (this.payload && this.payload.fields.link) ? this.payload.fields.link : '',
      template: this.payload && this.payload.fields.templateId,
      classes: (this.payload && this.payload.fields.classes) ? this.payload.fields.classes.join(' ') : '',
      content: []
      // scrollPos: {x: window.pageXOffset, y: window.pageYOffset}
    }
  },
  watch: {
    // 'pages': function (data) { // watches for pages in store to be populated/changed
    //   this.update(data)
    // }
  },
  directives: {
  },
  methods: {
    ...mapActions([
      'getContentTypes',
      'getEntries',
      'getEntry',
      'getAsset'
    ]),
    getSectionContent (data) {
      this.content = []
      data.forEach((n) => {
        this.content.push(n)
      })
    },
    kebabToCamel (s) {
      return s.replace(/(-\w)/g, m => m[1].toUpperCase())
    }
  },
  computed: {
    ...mapGetters([
      'domain',
      'pages'
    ])
  },
  created () {
    // this.setSectionInfo(this.payload.fields)
    this.payload.fields.content && this.getSectionContent(this.payload.fields.content)

    if (this.payload.fields.script) {
      let s = document.createElement('script')
      s.innerHTML = this.payload.fields.script
      s.setAttribute('id', `script-${this.payload.sys.id}`)
      // s.setAttribute('src',"//cdn.ckeditor.com/4.6.2/full/ckeditor.js");
      document.head.appendChild(s)
    }
  },
  updated () {
    this.payload.fields.content && this.getSectionContent(this.payload.fields.content)
  },
  mounted () {
    // window.addEventListener('scroll', () => { Vue.set(this, 'scrollPos', {x: window.pageXOffset, y: window.pageYOffset}) })
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/_sectionBase.js